import React from 'react'
import {IAppContext} from "../interfaces";

const internalContext = React.createContext<IAppContext>({
    user: undefined,
    loadingUserDetails: false,
    // eslint-disable-next-line
    updateUser: (user, history): void => {},
    clearUser: (): void => {},
    logout: (): void => {},
    refreshVerification: async () => null,
    observableMap: undefined
})

internalContext.displayName = "SecurSpaceAppContext"

export const AppContext = internalContext;
